/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>Show vertices</h4>

<p>Show or hide vertices.</p>
<p>In case some vertices are selected, hitting the icon will hide them.</p>
<p>Hitting the icon with the Shift-key pressed will hide all vertices, except for the selected ones.</p>

<ul class='shortcuts'>
    <li class='shortcuts__item'><b>Shortcuts:</b></li>
    <li class='shortcuts__item'><b>Q</b>: Hide vertices</li>
</ul>`;

export default function HideVerticesTooltip() {
    return h('div', { innerHTML: body });
}
